module.exports = __webpack_public_path__ + "img/back-icon.99c60af5.svg";